// extracted by mini-css-extract-plugin
export default {"navbar":"Navbar_navbar__AkVia","navbarLogo":"Navbar_navbarLogo__PNbev","navbarProfile":"Navbar_navbarProfile__LMRS1"};